import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { FinancialSettings } from "../financialReport.types";
import { requestFinancialSettings } from "./financialSettings.request";

const useFinancialSettings = (
  options?: QueryOptions<FinancialSettings, ApiServiceError<ApiError>>
) => {
  return useQuery({
    queryKey: ["financial-settings"],
    queryFn: requestFinancialSettings,
    onError: toastServerError,
    ...options
  });
};

export default useFinancialSettings;
